import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { useState } from "react";
import { BankingDepositsData } from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";
import { HistoryIcon } from "lucide-react";
import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { billingFiscalDocumentsStatus } from "@/features/billingBills/constants/billFiscalDocumentsStatus.constant";
import { formatDateTime } from "@/common/utils/formatters";
import DropdownMenu from "@/common/components/DropdownMenu";

interface FiscalDocumentsHistory {
  bankingDeposit: BankingDepositsData;
}

const FiscalDocumentsHistory = ({ bankingDeposit }: FiscalDocumentsHistory) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button variant="neutral" className="bg-gray-600">
            Histórico de Notas

            <HistoryIcon strokeWidth={1.5} size={20} />
          </Button>
        )}
        title="Histórico de notas"
        className="min-w-[580px] w-[80%] max-w-[840px]"
        bodyClassName="max-h-[calc(90vh-120px)] overflow-auto"
        body={(
          <div className="flex flex-col gap-4">
            {Number(bankingDeposit.fiscal_documents.length) === 0 && (
              <EmptyDataMessage
                className="max-h-80 text-white-800"
              />
            )}

            {bankingDeposit.fiscal_documents.map((fiscalDocument) => (
              <Box key={fiscalDocument.id} className="p-4 flex items-center justify-between gap-6">
                <div className="flex items-center flex-wrap gap-3">
                  <ResumeItem
                    valueClassName="text-sm"
                    label="Serial da nota"
                    value={fiscalDocument.serial || '--'}
                  />

                  <ResumeItem
                    valueClassName="text-sm"
                    label="Status no Sicof"
                    value={(
                      fiscalDocument.status &&
                      billingFiscalDocumentsStatus[fiscalDocument.status as keyof typeof billingFiscalDocumentsStatus]
                    ) || '--'}
                  />

                  <ResumeItem
                    valueClassName="text-sm"
                    label="Data/Hora de envio ao Sicof"
                    value={fiscalDocument.issued_at ? formatDateTime(new Date(fiscalDocument.issued_at)) : '--'}
                  />

                  <ResumeItem
                    valueClassName="text-sm"
                    label="Data/Hora do último retorno do Sicof"
                    value={fiscalDocument.confirmed_at ? formatDateTime(new Date(fiscalDocument.confirmed_at)) : '--'}
                  />
                </div>

                <div className="flex items-center gap-3">
                  <DropdownMenu
                    triggerClassName="text-white-800 text-nowrap"
                    triggerLabel="Baixar nota"
                    options={[
                      {
                        label: 'PDF',
                        onClick: () => fiscalDocument?.pdf?.url && window.open(fiscalDocument?.pdf?.url, '_blank'),
                        disabled: !fiscalDocument?.pdf?.url,
                      },
                      {
                        label: 'XML',
                        onClick: () => fiscalDocument?.xml?.url && window.open(fiscalDocument?.xml?.url, '_blank'),
                        disabled: !fiscalDocument?.xml?.url,
                      },
                    ]}
                  />
                </div>
              </Box>
            ))}
          </div>
        )}
      />
    </>
  );
};

export default FiscalDocumentsHistory;
